<template>
  <v-container fluid>
    <v-card flat>
      <v-card-title class="error white--text">
        Cash Flow Transactions
        <v-spacer></v-spacer>
        <v-btn
          v-if="sales.length"
          icon
          class="d-print-none"
          @click="PrintPage"
          small
          color="white"
        >
          <v-icon>fas fa-print</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-card flat>
          <v-card-title>
            <div>
              <cashDisplay
                small
                :isloading="isloading"
                :Balance="TotalBalance || []"
              ></cashDisplay>
            </div>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="fas fa-search"
              outlined
              label="Search"
              single-line
              hide-details
              class="d-print-none mr-3"
            ></v-text-field>
            <v-radio-group v-if="sales.length" row v-model="MyCash">
              <v-radio label="All" value="all"></v-radio>
              <!-- <v-radio label="USD" value="USD"></v-radio>
              <v-radio label="KES" value="KES"></v-radio> -->
              <v-radio
                :key="cash.AmountType"
                v-for="cash in TotalSale"
                :label="cash.AmountType"
                :value="cash.AmountType"
              ></v-radio>
            </v-radio-group>
            <!-- {{ TotalSale }} -->
          </v-card-title>

          <v-data-table
            :hide-default-footer="hideFooter"
            flat
            :headers="headers"
            :items="FilteredCash"
            :search="search"
          >
            <template v-slot:top>
              <v-toolbar flat color="grey lighten-4">
                <v-toolbar-title v-if="fromDate != '' && toDate != ''"
                  >{{ fromDate }} --- {{ toDate }}</v-toolbar-title
                >

                <v-divider class="mx-4" inset vertical></v-divider>
                <!-- <div class="flex-grow-1"></div> -->
                <searchDate
                  :searching="searching"
                  :SearchFun="OnSearch"
                ></searchDate>
                <v-spacer></v-spacer>
                <div>
                  <cashDisplay
                    :isloading="isloading"
                    :Balance="TotalSale"
                  ></cashDisplay>
                </div>
              </v-toolbar>
            </template>
            <template v-slot:[`item.in`]="{ item }">
              <p v-if="item.Acc == 'Dr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </p>
              <p v-else class="text-center">------------</p>
            </template>
            <template v-slot:[`item.out`]="{ item }">
              <p v-if="item.Acc == 'Cr'">
                {{ Math.abs(item.Amount).toLocaleString() }}
                {{ item.AmountType | MoneySigns }}
              </p>
              <p v-else class="text-center">------------</p>
            </template>
          </v-data-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import { EventBus } from "@/main";
import axios from "axios";
export default {
  components: {
    cashDisplay: () => import("@/components/coman/cashView"),
    searchDate: () => import("@/components/util/searchDate.vue"),
  },
  data() {
    return {
      SalesRepo: "/Reports/cash",
      searching: false,
      isloading: false,
      hideFooter: false,
      search: "",
      MyCash: "",
      fromDate: "",
      toDate: "",
      sales: [],
      TotalBalance: [],
      headers: [
        {
          text: "Date",
          align: "left",
          value: "date",
        },
        { text: "Description", value: "Name" },
        { text: "IN", value: "in" },
        { text: "OUT", value: "out" },
        // { text: "TYPE", value: "AmountType" },
        { text: "Account", value: "AccountName" },
        { text: "Details", value: "Details" },
        { text: "User", value: "User" },
        { text: "Ref", value: "Ref" },
        // { text: "CashRef", value: "CashRef" },
      ],
    };
  },
  computed: {
    FilteredCash() {
      if (!this.sales.length) return [];
      if (!this.MyCash || this.MyCash == "all") return this.sales;
      return this.sales.filter(type => type.AmountType == this.MyCash);
    },
    TotalSale() {
      if (!this.sales.length) return [];
      if (!this.sales.length) return [];
      let total = this.sales.reduce((result, item) => {
        let { Amount } = result[item.AmountType] || { Amount: 0 };
        result[item.AmountType] = {
          Amount: Amount + item.Amount,
          AmountType: item.AmountType,
        };
        return result;
      }, {});
      return Object.keys(total).map(key => total[key]);
    },
  },
  methods: {
    async PrintPage() {
      this.hideFooter = true;
      await EventBus.Printing(false);
      window.print();
      EventBus.Printing(true);
      this.hideFooter = false;
    },
    OnSearch(from, to) {
      this.fromDate = from;
      this.toDate = to;

      this.sales = [];
      this.TotalBalance = [];

      this.searching = true;
      this.isloading = true;
      let balanceReq = `${this.SalesRepo}/balance`;

      axios
        .all([
          this.GetReq(this.SalesRepo, { from, to }),
          this.GetReq(balanceReq, { from, to }),
        ])
        .then(result => {
          // console.log(result[0]);
          this.isloading = false;
          this.searching = false;
          this.sales = result[0].data;
          this.TotalBalance = result[1].data;
        })
        .catch(() => {
          this.isloading = false;
          this.searching = false;
          // console.log(error);
        });
    },
    GetReq(url, query = {}) {
      if (!url) url = this.SalesRepo;
      // if (!query) query = { from: this.fromDate, to: this.toDate };
      return this.$store.dispatch("FIND_BY_VALUE", {
        url,
        query,
      });
    },
    loadSales() {
      try {
        // this.$store
        //   .dispatch("GET_ONLY", this.SalesRepo)
        this.searching = true;
        this.isloading = true;
        let balanceReq = `${this.SalesRepo}/balance`;

        axios
          .all([this.GetReq(), this.GetReq(balanceReq)])
          .then(value => {
            this.searching = false;
            this.isloading = false;
            this.sales = value[0].data;
            this.TotalBalance = value[1].data;
          })
          .catch(err => {
            this.searching = false;
            this.isloading = false;
            console.log(err);
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
  created() {
    // const { date } = this.Current();
    // this.fromDate = date;
    // this.toDate = date;
    this.loadSales();
  },
};
</script>
